export default __webpack_public_path__ + "static/media/2.a30375a3.png";